import script from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"

import "./GroupSurveys.vue?vue&type=style&index=0&id=4a7330bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7330bc"]])

export default __exports__